import BaseFeature from '../../foundation/base/base';

class Hero extends BaseFeature {
	constructor(element) {
		super(element);

		this.initDomCache();

		this.el = element;
		this.ticking = false;
		this.hero = this.el;
		this.body = window.features.dom.body;
		this.expandHero = this.el.querySelector('[data-js="expandHero"]');
		this.heroAsset = this.el.querySelector('[data-js="heroAsset"]');
		this.heroContent = this.el.querySelector('[data-js="heroContent"]');
		this.heroBackground = document.querySelectorAll('.m-hero__image');
		this.heroSlideupContent = this.el.querySelector('[data-js="heroSlideupContent"]');
		this.addClick();
		this.log();
	}


	addClick() {
		// Observe the target

		const heroContent = this.heroSlideupContent;
		function onIntersection(entries) {
			entries.forEach((entry) => {
				heroContent.classList.toggle('is-visible', entry.intersectionRatio > 0);
			});
		}
		if (this.heroSlideupContent) {
			// configure the observer
			const intersectionObserverOptions = {
				root: null,
				rootMargin: '150px',
				threshold: 1.0
			};
			const observer = new IntersectionObserver(onIntersection, intersectionObserverOptions);
			// provide the observer with a target
			observer.observe(heroContent);
		}

		// If both elements are used
		if (this.heroContent && this.heroAsset) {
			window.addEventListener('scroll', () => {
				// Calculate the speed based on the scroll
				const yPosContent = 0 - window.pageYOffset / 30;
				const yPosImage = 0 - window.pageYOffset / 30;

				// Apply the calculated value
				this.heroContent.style.top = 50 + yPosContent + '%';
				this.heroAsset.style.bottom = 0 + yPosImage + '%';
			});
		}

		// Expand submenu
		if (this.expandHero) {
			this.expandHero.addEventListener('click', () => {
				this.el.classList.toggle('is-folded-content');

				// Accessibility
				let elementState = this.expandHero.getAttribute('aria-expanded');
				if (elementState === 'true') {
					elementState = 'false';
				} else {
					elementState = 'true';
				}
				this.expandHero.setAttribute('aria-expanded', elementState);
			});
		}
	}
}

export default Hero;
